// src/components/NavBar.js

import React, { useState } from 'react';
import Navbar from 'react-bootstrap/Navbar';
import 'bootstrap/dist/css/bootstrap.min.css';
import logo from '../../Images/coalogo.png';
import logoconault from '../../Images/conautlogo.jpeg';
import logoweg from '../../Images/weglogo.jpeg';
import "./NavBar.css";
import Button1 from '../Buttons/HomeButton';
import Button2 from '../Buttons/ServicosButton';
import Button3 from '../Buttons/CatalogoButton';
import Button4 from '../Buttons/ContatoButton';

// CORREÇÃO: Trocamos 'useNavigate' por 'useHistory'
import { Link, useLocation, useHistory } from 'react-router-dom'; 

export default function NavBar(){
    const location = useLocation();
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    
    // CORREÇÃO: Inicialize o useHistory
    const history = useHistory(); 

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };
    
const handleDualAction = (e) => { // <--- Recebe o evento 'e'
  e.preventDefault(); // <--- IMPEDE A NAVEGAÇÃO PADRÃO DO LINK
  
  const urlNovaAba = 'https://coautomacao.loja.click/';
  const urlRedirecionamento = '/WEG'; 

  // Ação 1: Abre a nova aba (deve ser a primeira ação )
  window.open(urlNovaAba, '_blank' );
  
  // Ação 2: Redireciona a página atual
  history.push(urlRedirecionamento); 
};

    return (
        <div className="backgroundNav">
            <Navbar className="NavBar-NavBarCSS" bg="navbar navbar-light bg-lights justify-content-between">
                <Link to="/">
                    <img src={logo} alt="logo"/>
                </Link>
                <Link to="/">
                    <img src={logoweg} alt="logo2"/>
                </Link>
                <Link to="/">
                    <img src={logoconault} alt="logo3"/>
                </Link>

                <button className="hamburger-button" onClick={toggleMenu}>
                    ☰
                </button>

                
                <div className={`NavBar-ButtonContent ${isMenuOpen ? 'open' : ''}`}>
                     
                    <div className="button-group navbar">
                        <Button1 currentPath={location.pathname} buttonPath="/empresa" />
                        <Button2 currentPath={location.pathname} buttonPath="/servicos" />
                        <Button3 currentPath={location.pathname} buttonPath="/WEG"/>
                        <Button4 currentPath={location.pathname} buttonPath="/contato" />
                    </div>
                </div>
            </Navbar>
        </div>
    )
}
